import React from 'react';
import PropTypes from 'prop-types';

import Asterisk from '../Asterisk';
import FieldError from '../FieldError';

// const options = [
//   { value: 'male', label: 'MALE' },
//   { value: 'female', label: 'FEMALE' },
// ]

const SelectInput = ({
  required,
  label,
  name,
  values,
  errors,
  touched,
  className = '',
  inputClassName = '',
  optionClassName = '',
  disabled = false,
  readOnly = false,
  onChange = () => { },
  onBlur = () => { },
  options = [],
  description = '',
  size,
  popover = null,
  inline = false,
  labelWidth = 6,
  inputWidth = 6,
  dataPrivate = true,
  labelDescription,
}) => {
  let sizeClass = '';
  if (size === 'lg') {
    sizeClass = 'form-select-lg';
  } else if (size === 'sm') {
    sizeClass = 'form-select-sm';
  }

  let containerClassName = `form-group col-12 rounded ${className}`;
  if (!disabled && !readOnly && errors[name] && touched[name]) {
    containerClassName += ' has-danger';
  }
  if (readOnly) {
    containerClassName += ' bg-light-hover read-only';
  }
  if (inline) {
    containerClassName += ' row';
  }

  let labelClassName = 'form-label';
  if (inline) {
    labelClassName += ` col-12 col-sm-${labelWidth}`;
    if (readOnly) {
      labelClassName += ' mb-0';
    }
  } else {
    labelClassName += ' mb-0';
  }

  return (
    <div className={containerClassName}>
      <label htmlFor={name} className={labelClassName}>
        {label}{readOnly && ':'}{required && !readOnly && <Asterisk />}
      </label>
      {popover}
      {labelDescription && <div className='form-text'>{labelDescription}</div>}
      <div className={`${inline ? `col-12 col-sm-${inputWidth}` : ''}`} data-private={dataPrivate}>
        {readOnly
          ? <span>{values[name]}</span>
          : (
            <>
              <select
                id={name}
                className={`form-select ${sizeClass} ${inputClassName}`}
                aria-label={description || name}
                aria-required={required}
                name={name}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                value={values[name]}>
                <option value=''>Select</option>
                {options.map((d, i) => (
                  <option
                    key={i}
                    className={optionClassName}
                    value={d.value}
                  >
                    {d.label}
                  </option>
                ))}
              </select>
              <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />
            </>
          )
        }
      </div>
    </div>
  );
};

SelectInput.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: PropTypes.array,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  optionClassName: PropTypes.string,
  description: PropTypes.string,
  dataCy: PropTypes.string,
  labelDescription: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  size: PropTypes.string,
  popover: PropTypes.node,
  inline: PropTypes.bool,
  labelWidth: PropTypes.number,
  inputWidth: PropTypes.number,
  dataPrivate: PropTypes.bool,
};

export default SelectInput;
